import React,{useState,useEffect} from 'react'
import VideoCoursesListingPage from '../videoCourses/VideoCoursesListingPage';

import { useDispatch, useSelector } from 'react-redux';
import { getVideoProductCategories, getProductCategoriesDataClear, getSubProductCategoriesDataClear } from '../../redux/courses/actions';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import {
  SessionKeys,
} from "../../utils/AppUtils";

export default function ProviderVideoCategories() {
    const [isLoading, setIsLoading] = useState(true);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const providerId = params.get('provider_id');

    const [defaultCategoryId, setdefaultCategoryId] = useState("");
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authBroker = useSelector((state) => state.auth.authBroker);
    const productCategoriesData = useSelector(
      (state) => state.courses.videoProductCategories
    );


    useEffect(()=>{
      dispatch(getSubProductCategoriesDataClear());
          dispatch(getProductCategoriesDataClear());
    },[])
  
    useEffect(() => {
      if (!_.isEmpty(authBroker)) {
        setIsLoading(true)
        dispatch(
          getVideoProductCategories({
            module: "getProductCategoryFromWoo",
            brokerId: authBroker.payload.user.company_id,
            type:'videos',
            provider_id : providerId ? providerId : '',
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          })
        );
      }
    }, [authBroker])
  
    useEffect(() => {
      if (
        !_.isEmpty(productCategoriesData) && providerId
      ) {setIsLoading(false)
  
        let categoryArray = [];
        if (
          productCategoriesData.status === "success"
        ) {
          if (productCategoriesData?.payload?.length > 0) {
            categoryArray = [...categoryArray, ...productCategoriesData.payload];
          }
          categoryArray = _.sortBy(categoryArray, 'categoryId')
          console.log("video_category",categoryArray)
          // setCourseCategories(categoryArray);
          setdefaultCategoryId(categoryArray[0].categoryId)
        }
  
  
      }
    }, [productCategoriesData]);

    return (
    <>
    {/* <Loader start={isLoading} /> */}
    {/* <Page>
    <MenuCoaching providerId={providerId} selectedItem={2}/>
    <VideoCategoryListingSection
    isLoading={isLoading}
    setIsLoading={setIsLoading}
   />
    </Page> */}

    
    <VideoCoursesListingPage 
     isLoading={isLoading}
     setIsLoading={setIsLoading}
     defaultCategoryId = {defaultCategoryId}
    />
    
  </>
    
  )
}
